module.exports = __webpack_public_path__ + "img/EXEMPLO_DE_CAPA.9820f123.jpg";